export default {
  F01_01_BCQT: '01_01_BCQT',
  F01_01_BCQT_BudgetItemDetail: '01_01_BCQT_BudgetItemDetail',
};
